var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "column large-3" }, [
          _c("div", { staticClass: "row nested-row" }, [
            _c(
              "div",
              { staticClass: "course__filters column panel bg-white radius" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.query,
                      expression: "query",
                    },
                  ],
                  staticClass: "radius no-margin",
                  attrs: {
                    placeholder: _vm.t("courses.search_placeholder"),
                    type: "search",
                  },
                  domProps: { value: _vm.query },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.query = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.filterableTagGroups, function (group) {
                  return _c("div", [
                    _c(
                      "div",
                      {
                        class: {
                          course__filters__title: true,
                          "course__filters__title--open": !_vm.isCollapsed(
                            group.title
                          ),
                        },
                        attrs: { title: _vm.getHoverText(group.title) },
                        on: {
                          click: function ($event) {
                            return _vm.toggleCollapse(group.title)
                          },
                        },
                      },
                      [
                        _c("strong", {
                          staticClass: "text-red",
                          staticStyle: { "text-transform": "uppercase" },
                          domProps: { textContent: _vm._s(group.title) },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          class: _vm.getGroupClasses(group.title),
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isCollapsed(group.title)
                      ? _c(
                          "ul",
                          { staticClass: "select-list fa-ul" },
                          _vm._l(group.tags, function (tag) {
                            return _c("li", [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filteredTags,
                                      expression: "filteredTags",
                                    },
                                  ],
                                  staticClass: "no-margin",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: tag.id,
                                    checked: Array.isArray(_vm.filteredTags)
                                      ? _vm._i(_vm.filteredTags, tag.id) > -1
                                      : _vm.filteredTags,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.filteredTags,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = tag.id,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.filteredTags = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.filteredTags = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.filteredTags = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("i", { staticClass: "fa fa-li text-gray" }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: { textContent: _vm._s(tag.title) },
                                }),
                              ]),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr", { staticClass: "course__filters__divider" }),
                  ])
                }),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    {
                      class: {
                        course__filters__title: true,
                        "course__filters__title--open":
                          !_vm.isCollapsed("providers"),
                      },
                      attrs: { title: _vm.getHoverText("providers") },
                      on: {
                        click: function ($event) {
                          return _vm.toggleCollapse("providers")
                        },
                      },
                    },
                    [
                      _c("strong", {
                        staticClass: "text-red",
                        staticStyle: { "text-transform": "uppercase" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("courses.course_providers")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: _vm.getGroupClasses("providers"),
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isCollapsed("providers")
                    ? _c(
                        "ul",
                        { staticClass: "select-list fa-ul" },
                        _vm._l(_vm.filterableProviders, function (provider) {
                          return _c("li", [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filteredProviders,
                                    expression: "filteredProviders",
                                  },
                                ],
                                staticClass: "no-margin",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: provider.name,
                                  checked: Array.isArray(_vm.filteredProviders)
                                    ? _vm._i(
                                        _vm.filteredProviders,
                                        provider.name
                                      ) > -1
                                    : _vm.filteredProviders,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.filteredProviders,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = provider.name,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.filteredProviders = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.filteredProviders = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.filteredProviders = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("i", { staticClass: "fa fa-li text-gray" }),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(provider.name),
                                },
                              }),
                            ]),
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column large-9 course__list" },
          [
            _c("div", { staticClass: "row nested-row" }, [
              _c("div", { staticClass: "column" }, [
                _vm.hasFilters
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.t(
                              "courses.displaying_number_of_filtered_courses",
                              {
                                filtered: _vm.displayedCourses.length,
                                total: _vm.courses.length,
                              }
                            )
                          ) +
                          "\n            "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "right",
                          on: { click: _vm.clearFilters },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("courses.clear_filters")) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "fa fa-times fa-fw text-blue",
                          }),
                        ]
                      ),
                    ])
                  : _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.t(
                              "courses.displaying_number_of_total_courses",
                              {
                                total: _vm.courses.length,
                              }
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
              ]),
            ]),
            _vm._v(" "),
            _vm._l(_vm.rows, function (row) {
              return _c(
                "div",
                { staticClass: "row nested-row" },
                _vm._l(row, function (course) {
                  return _c(
                    "div",
                    {
                      class: ["column", "small-" + 12 / _vm.itemsPerRow, "end"],
                      staticStyle: {
                        "margin-bottom": "1.875rem",
                        cursor: "pointer",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showCourse(course)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "course" }, [
                        _c(
                          "div",
                          {
                            class: {
                              course__image: true,
                              "course__image--bc": course.isBc,
                              "course__image--property-management":
                                course.isPropertyManagement,
                            },
                            attrs: {
                              "data-property-management": _vm.t(
                                "courses.property_management_label"
                              ),
                              "data-bc": "BC",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "course__image-img",
                              attrs: { src: course.imageUrl },
                              on: {
                                error: function ($event) {
                                  return _vm.onCourseImageError($event, course)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "panel bg-white no-margin course__label",
                          },
                          [
                            _c("h6", {
                              staticClass: "text-blue",
                              domProps: { textContent: _vm._s(course.title) },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.courseModal.isShowing
        ? _c(
            "Modal",
            {
              attrs: { "show-close-button": true, size: "medium" },
              on: {
                close: function ($event) {
                  _vm.courseModal.isShowing = false
                },
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "column large-4" }, [
                  _c("div", { staticClass: "hide-for-large-up" }, [
                    _c(
                      "button",
                      {
                        staticClass: "tiny secondary radius",
                        attrs: {
                          disabled: !_vm.hasPreviousCourse,
                          title: _vm.t("courses.modal_previous"),
                        },
                        on: { click: _vm.showPreviousCourse },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-chevron-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "tiny secondary radius",
                        attrs: {
                          disabled: !_vm.hasNextCourse,
                          title: _vm.t("courses.modal_next"),
                        },
                        on: { click: _vm.showNextCourse },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-chevron-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "course-modal__image-holder": true,
                        "course-modal__image-holder--bc":
                          _vm.courseModal.course.isBc,
                        "course-modal__image-holder--property-management":
                          _vm.courseModal.course.isPropertyManagement,
                      },
                      attrs: {
                        "data-property-management": _vm.t(
                          "courses.property_management_label"
                        ),
                        "data-bc": "BC",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "course-modal__image",
                        attrs: { src: _vm.courseModal.course.imageUrl },
                        on: {
                          error: function ($event) {
                            return _vm.onCourseImageError(
                              $event,
                              _vm.courseModal.course
                            )
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-dark-gray no-margin" }, [
                    _vm._v(_vm._s(_vm.t("courses.course_provided_by"))),
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "course-modal__provider-logo",
                    attrs: { src: _vm.logo(_vm.courseModal.course.providerId) },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column large-8" },
                  [
                    _c("div", { staticClass: "show-for-large-up" }, [
                      _c(
                        "button",
                        {
                          staticClass: "tiny secondary radius",
                          attrs: {
                            disabled: !_vm.hasPreviousCourse,
                            title: _vm.t("courses.modal_previous"),
                          },
                          on: { click: _vm.showPreviousCourse },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-chevron-left",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "tiny secondary radius",
                          attrs: {
                            disabled: !_vm.hasNextCourse,
                            title: _vm.t("courses.modal_next"),
                          },
                          on: { click: _vm.showNextCourse },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-chevron-right",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("h3", {
                      domProps: {
                        textContent: _vm._s(_vm.courseModal.course.title),
                      },
                    }),
                    _vm._v(" "),
                    _vm.isEnglishOnly(_vm.courseModal.course)
                      ? _c("p", [
                          _c("i", [
                            _vm._v(
                              _vm._s(_vm.t("courses.available_in_english_only"))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h5", [_vm._v(_vm._s(_vm.t("courses.course_fee")))]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        textContent: _vm._s(_vm.courseModal.course.cost),
                      },
                    }),
                    _vm._v(" "),
                    _c("h5", [
                      _vm._v(_vm._s(_vm.t("courses.course_description"))),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.courseModal.course.description),
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.courseModal.tagGroups, function (group) {
                      return [
                        _c("h5", {
                          domProps: { textContent: _vm._s(group.name) },
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._l(group.tags, function (tag, index) {
                              return [
                                _c("span", {
                                  domProps: { textContent: _vm._s(tag) },
                                }),
                                index !== group.tags.length - 1
                                  ? [_vm._v(", ")]
                                  : _vm._e(),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hide-for-large-up" }, [
                      _vm.courseModal.course.documentUrl.length
                        ? _c("p", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.courseModal.course.documentUrl,
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.t("courses.view_course_outline")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "button tiny radius no-margin",
                          attrs: {
                            href: _vm.courseModal.course.purchaseUrl,
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.t("courses.buy_course")))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "show-for-large-up" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tiny radius no-margin",
                          attrs: {
                            href: _vm.courseModal.course.purchaseUrl,
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.t("courses.buy_course")))]
                      ),
                      _vm._v(" "),
                      _vm.courseModal.course.documentUrl.length
                        ? _c(
                            "a",
                            {
                              staticStyle: { "margin-left": "15px" },
                              attrs: {
                                href: _vm.courseModal.course.documentUrl,
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.t("courses.view_course_outline")) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  2
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }